import { render, staticRenderFns } from "./diff_with_note.vue?vue&type=template&id=a6ab02a8&"
import script from "./diff_with_note.vue?vue&type=script&lang=js&"
export * from "./diff_with_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports